import React,{useEffect, useState} from 'react'
import { Link } from "react-router-dom"
import axios from'axios'
import { Button, CardActionArea, CardActions, Card, CardContent, CardMedia, Typography, Grid } from '@material-ui/core';


const URL = 'https://newsapi.org/v2/top-headlines?' + 'country=us&' + 'category=technology&' + 'apiKey=1e98ab5830bb43eeac2452c526bb8293';

const News = () => {
    const [news, setNews] = useState([])
    const [search, setSearch] = useState('technology')
 
    
    
     
      useEffect(() => {
        const getUser = () => {
          var options = {
            method: 'GET',
            url: 'https://newscatcher.p.rapidapi.com/v1/search_free',
            params: {q: search, lang: 'en', media: 'True'},
            headers: {
              'x-rapidapi-host': 'newscatcher.p.rapidapi.com',
              'x-rapidapi-key': '3a5da310camsh23eda33e06b903ep190ed9jsn52323cba3df5'
            }
          };
          
          axios.request(options).then((response) => {
            console.log(response.data);
            setNews(response?.data?.articles)
          }).catch((error) => {
            console.error(error);
          });
        }
        
        getUser()
      },[search])

     


      const sp = news.slice(0, 6)
    return (
      <>
          <nav class="navbar navbar-light bg-green-700 my-3 px-3">
          <Typography variant='body' className="headings">News<span className="text-green-500">Technology </span></Typography>
  <div class="container-fluid "  style={{justifyContent: 'center', alignItems: 'center', textAlign: "center", marginBottom: '15px'}}>
    <form class="d-flex " >
      <input class="form-control me-1" style={{boxShadow: '-2px 7px 21px -9px rgba(0, 0, 0, 0.75)'}} type="search" onChange={(e) => setSearch(e.target.value)}  placeholder="Look for news" aria-label="Search"/>
      {/* <button class=" btn btn-success "  style={{height: '40px'}} type="submit" value={search}>Search</button> */}
    </form>
  </div>
</nav>
      <Grid  container  spacing={3} className="" >
        {sp?.map(({title, media, description, author, url }) => (
          <Grid item xs={6}  className="  " key={title}>
            
            <Card className=""  style={{ maxWidth: 335, maxHeight: 300}}   >
          
                      <CardActionArea  >
                      <CardMedia
                        component="img"
                        height="100"
                        image={media}
                        alt={title}
                        style={{maxHeight: 100 }}
                      />
                      <CardContent className='bg-green-100' >
                        <Typography className='text1 font-bold text-1xl' gutterBottom variant="body" component="div">
                          {title}
                        </Typography>
                        
                        <Typography variant="body2" color="text.secondary">
                          {author}
                        </Typography>
                        <a href={url}><strong>More...</strong></a>
                      </CardContent>
                    </CardActionArea>
                    
             
            </Card>
        </Grid>
       
          ))};
    </Grid>
        </>
         
    )
}

export default News


// async function getUser() {
        
//   const response = await axios.get(URL);
//   const data = response?.data?.articles
//   console.log(data)
//   setNews(data)

// }

// axios.get(URL).then((response) => {
//   console.log(response?.data);
//   const data = response?.data?.articles
//   setNews(data)
// }).catch((error) => {
//   console.log(error);
// });

